import { type Repub } from '@cx-modules/types';

/**
 * Builds a full URL for an article with the correct domain and repub prefix
 * @param relativeUrl - The relative URL from the API response
 * @param repub - The repub code (e.g., 'US', 'OC', etc.)
 * @returns Full URL with domain and repub prefix
 */
export const buildArticleUrl = (relativeUrl: string, repub: Repub, rootUrl?: string): string => {
  if (rootUrl && rootUrl.startsWith('http')) {
    // if the rootUrl start with http, we need to change it to https because cx web returns links with http
    rootUrl = rootUrl.replace(/^http:/, 'https:');
  }
  const baseUrl = rootUrl || 'https://www.oddschecker.com';
  const repubPrefix = repub.toLowerCase();

  // Ensure the relative URL doesn't start with a slash
  const cleanRelativeUrl = relativeUrl.startsWith('/') ? relativeUrl.slice(1) : relativeUrl;

  return `${baseUrl}/${repubPrefix}/${cleanRelativeUrl}`;
};
